import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import useOnScreen from "@/hooks/useOnScreen";
export interface StatItem {
  label: string;
  value: number;
  prefix?: string;
  suffix?: string;
}
interface StatsCounterProps {
  items: StatItem[];
  children: (counts: number[]) => React.ReactNode;
}
const StatsCounter = t0 => {
  const $ = _c(13);
  const {
    items,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      threshold: 0.3
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    ref,
    inView
  } = useOnScreen(t1);
  let t2;
  if ($[1] !== items) {
    t2 = items.map(_temp);
    $[1] = items;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [counts, setCounts] = useState(t2);
  let t3;
  let t4;
  if ($[3] !== inView || $[4] !== items) {
    t3 = () => {
      if (!inView) {
        return;
      }
      const startTime = performance.now();
      const easeOutCubic = _temp2;
      const animate = now => {
        const progress = Math.min(1, (now - startTime) / 1600);
        const eased = easeOutCubic(progress);
        setCounts(items.map(item => Math.round(item.value * eased)));
        if (progress < 1) {
          requestAnimationFrame(animate);
        }
      };
      requestAnimationFrame(animate);
    };
    t4 = [inView, items];
    $[3] = inView;
    $[4] = items;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== children || $[8] !== counts) {
    t5 = children(counts);
    $[7] = children;
    $[8] = counts;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== ref || $[11] !== t5) {
    t6 = <div ref={ref}>{t5}</div>;
    $[10] = ref;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default StatsCounter;
function _temp() {
  return 0;
}
function _temp2(t) {
  return 1 - Math.pow(1 - t, 3);
}